import createVueComponent from '../createVueComponent';

const ArrowBigRight = createVueComponent('ArrowBigRightIcon', [
  ['path', { d: 'M21 12l-7-7v4H3v6h11v4z' }],
]);

export default ArrowBigRight;
